import { from, map, switchMap, take } from 'rxjs';
import { axios } from '../axios';
import { EventType } from './meta';
export var FollowableEventTriggerType = /*#__PURE__*/ function(FollowableEventTriggerType) {
    FollowableEventTriggerType["Follow"] = "Follow";
    FollowableEventTriggerType["Notify"] = "Notify";
    FollowableEventTriggerType["None"] = "None";
    return FollowableEventTriggerType;
}({});
export const FollowableEventTriggerTypes = [
    "Follow",
    "Notify",
    "None"
];
export var DateFieldEventTriggerType = /*#__PURE__*/ function(DateFieldEventTriggerType) {
    DateFieldEventTriggerType["AssignedTasks"] = "AssignedTasks";
    DateFieldEventTriggerType["AllTasks"] = "AllTasks";
    return DateFieldEventTriggerType;
}({});
export const DateFieldEventTriggerTypes = [
    "AssignedTasks",
    "AllTasks"
];
export var Channel = /*#__PURE__*/ function(Channel) {
    Channel["Email"] = "EMAIL";
    Channel["InApp"] = "IN_APP";
    Channel["Slack"] = "SLACK";
    return Channel;
}({});
export var ReminderOption = /*#__PURE__*/ function(ReminderOption) {
    ReminderOption["SameDay"] = "SameDay";
    ReminderOption["OneDayBefore"] = "OneDayBefore";
    ReminderOption["TwoDaysBefore"] = "TwoDaysBefore";
    ReminderOption["ThreeDaysBefore"] = "ThreeDaysBefore";
    ReminderOption["OneWeekBefore"] = "OneWeekBefore";
    return ReminderOption;
}({});
export const isReminder = (configuration)=>[
        EventType.TaskStartDateReminder,
        EventType.TaskDueDateReminder
    ].includes(configuration.eventType);
export const isDateField = (configuration)=>[
        EventType.TaskStartDateChanged,
        EventType.TaskDueDateChanged,
        EventType.TaskDueDateOverdue
    ].includes(configuration.eventType);
export const isFollowable = (configuration)=>[
        EventType.TaskCreated
    ].includes(configuration.eventType);
export const isSimple = (configuration)=>!isReminder(configuration) && !isDateField(configuration) && !isFollowable(configuration);
export const configuration = {
    get: ()=>axios().pipe(take(1), switchMap(({ get })=>from(get('/system-rules/config'))), map((response)=>response.data)),
    update: (updated)=>axios().pipe(take(1), switchMap(({ post })=>from(post('/system-rules/config', updated))))
};
export const customerConfiguration = {
    get: ()=>axios().pipe(take(1), switchMap(({ get })=>from(get('/customer-notification-config'))), map((response)=>response.data)),
    update: (updated)=>axios().pipe(take(1), switchMap(({ post })=>from(post('/customer-notification-config', updated))))
};
